import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "info-modify-container flex-center" };
var _hoisted_2 = { class: "info-config-block" };
var _hoisted_3 = { class: "info-config-row" };
var _hoisted_4 = { class: "info-config-block" };
var _hoisted_5 = { class: "info-config-row" };
var _hoisted_6 = { class: "info-config-row" };
var _hoisted_7 = { class: "info-config-row" };
var _hoisted_8 = { class: "info-config-row" };
var _hoisted_9 = { class: "info-config-block" };
var _hoisted_10 = { class: "info-config-row" };
var _hoisted_11 = { class: "info-config-row" };
var _hoisted_12 = { class: "info-config-block" };
var _hoisted_13 = { class: "info-config-row" };
var _hoisted_14 = { class: "info-config-title" };
var _hoisted_15 = { class: "info-config-bottom-info-set" };
var _hoisted_16 = {
    key: 1,
    class: "info-config-row"
};
var _hoisted_17 = { class: "info-config-bottom-info-set" };
var _hoisted_18 = { class: "info-config-block" };
var _hoisted_19 = { class: "info-config-row" };
var _hoisted_20 = { class: "info-config-row" };
var _hoisted_21 = { class: "info-config-row" };
var _hoisted_22 = { class: "info-config-row" };
import { computed, ref, watch } from "vue";
import api from "@/utils/api";
import CustomSVG from "@/components/custom/CustomSVG.vue";
var updateTrigerTime = 1000;
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup: function (__props) {
        var _this = this;
        var webInfo = ref({
            name: "清蒸QB",
            sitename: "清蒸QB的小窝",
            bussinessCardTitle: "Get A Break!",
            bussinessCardDisc: "Don't wait for someone to bring you flowers.\nPlant your own garden and decorate your own soul.",
            welcomeCard: {
                subtitle: "天气晴朗 万物可爱",
                content: "你发现了一个游离在互联网边缘的小网站\n整个网站没有使用任何博客框架，一个个标签堆起来的，也许某些地方简陋到会长出二叉树也说不定www",
            },
            footDirect: {
                萌ICP备20241369号: "https://icp.gov.moe/?keyword=20241369",
                桂ICP备2024039130号: "https://beian.miit.gov.cn/",
            },
            contractDirect: {
                Github: "https://github.com/qingzhengQB",
                QQ: "https://qm.qq.com/q/d3iqoe35TO",
                Email: "mailto:admin@qpqpqpqpqp.com",
                Bilibili: "https://space.bilibili.com/473247452",
            },
        });
        api.request
            .get("/getwebinfo")
            .then(function (res) {
            webInfo.value = res.data;
            watch(function () { return webInfo.value; }, function (oldVal, newVal) {
                clearTimeout(updateTrigerTimeout);
                updateTrigerTimeout = setTimeout(function () {
                    saveInfo();
                    clearTimeout(updateTrigerTimeout);
                }, updateTrigerTime);
            }, { deep: true } // 深度监听，在监听对象时必须要加上这个选项，否则失效
            );
        })
            .catch(function (err) {
            window.$notifyError("获取网站信息失败", err.response.msg);
        });
        var updateTrigerTimeout = undefined;
        var recommendPostName = ref(null);
        var recommendPostId = ref(null);
        api.request
            .get("/recommendpost")
            .then(function (resp) {
            recommendPostName.value = resp.data.title;
            recommendPostId.value = resp.data.id;
        })
            .catch(function (err) {
            console.error("获取推荐文章失败: ", err);
            window.$message.error("获取推荐文章失败");
        });
        var saveInfo = function (hasMask) {
            if (hasMask === void 0) { hasMask = false; }
            return __awaiter(_this, void 0, void 0, function () {
                var requestFunc;
                return __generator(this, function (_a) {
                    requestFunc = hasMask ? api.request : api.requestWithSmallLoad;
                    return [2 /*return*/, requestFunc
                            .post("/modifywebinfo", webInfo.value)
                            .then(function (resp) { })
                            .catch(function (err) {
                            window.$notifyError("更新网站数据失败", err.response.msg);
                        })];
                });
            });
        };
        var postList = ref([]);
        api.request
            .get("/postlist")
            .then(function (res) {
            var resp = res;
            postList.value = resp.data;
        })
            .catch(function (err) {
            window.$message.error("获取文章列表失败");
            console.error("获取文章列表失败: ", err);
        });
        var renderPostList = computed(function () {
            return postList.value
                .filter(function (elem) {
                return !elem.is_delete;
            })
                .map(function (elem) {
                return {
                    label: elem.title,
                    value: elem.id,
                    key: elem.id,
                };
            });
        });
        var handleUpdateRecommendPost = function (postID) {
            console.log("变更推荐文章ID: ", postID);
            var recommendPost = postList.value.find(function (elem) {
                return elem.id === postID;
            });
            if (recommendPost) {
                api.request
                    .quickPost("/setrecommandpost", {
                    id: postID,
                })
                    .then(function (resp) {
                    window.$notifySuccess("设置推荐文章成功", "推荐文章已经被推送了");
                    recommendPostName.value = recommendPost.title;
                    recommendPostId.value = postID;
                })
                    .catch(function (err) {
                    window.$notifyError("设置推荐文章失败", err.response.msg);
                    console.error("设置推荐文章失败: ", err);
                });
            }
        };
        var isAddingBottomField = ref(false);
        var addingBottomFieldName = ref(""), addingBottomFieldUrl = ref("");
        watch(isAddingBottomField, function () {
            addingBottomFieldName.value = "";
            addingBottomFieldUrl.value = "";
        });
        var createNewBottomField = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                isAddingBottomField.value = true;
                return [2 /*return*/];
            });
        }); };
        var createNewBottomFieldActive = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        webInfo.value.footDirect[addingBottomFieldName.value] =
                            addingBottomFieldUrl.value;
                        isAddingBottomField.value = false;
                        return [4 /*yield*/, saveInfo(true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var deleteBottomField = function (title) {
            delete webInfo.value.footDirect[title];
            saveInfo(true);
            window.$notifySuccess("删除底部信息成功", "底部信息已经被删除啦");
        };
        return function (_ctx, _cache) {
            var _component_n_divider = _resolveComponent("n-divider");
            var _component_n_select = _resolveComponent("n-select");
            var _component_n_input = _resolveComponent("n-input");
            var _component_n_icon = _resolveComponent("n-icon");
            var _component_n_button = _resolveComponent("n-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_n_divider, { class: "info-modify-divider usn" }, {
                        default: _withCtx(function () { return _cache[13] || (_cache[13] = [
                            _createTextVNode(" 推荐文章选择 ")
                        ]); }),
                        _: 1
                    }),
                    _createElementVNode("div", _hoisted_3, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "info-config-title" }, " 文章选择 / post ", -1)),
                        _createVNode(_component_n_select, {
                            class: "info-config-content",
                            value: recommendPostName.value,
                            "onUpdate:value": [
                                _cache[0] || (_cache[0] = function ($event) { return ((recommendPostName).value = $event); }),
                                handleUpdateRecommendPost
                            ],
                            options: renderPostList.value,
                            placeholder: "选择推荐文章（可输入过滤）",
                            filterable: true
                        }, null, 8, ["value", "options"])
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_n_divider, { class: "info-modify-divider usn" }, {
                        default: _withCtx(function () { return _cache[15] || (_cache[15] = [
                            _createTextVNode(" 基本信息配置 ")
                        ]); }),
                        _: 1
                    }),
                    _createElementVNode("div", _hoisted_5, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "info-config-title" }, " 网站名称 / name ", -1)),
                        _createVNode(_component_n_input, {
                            class: "info-config-content",
                            value: webInfo.value.name,
                            "onUpdate:value": _cache[1] || (_cache[1] = function ($event) { return ((webInfo.value.name) = $event); }),
                            placeholder: "网站名称"
                        }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "info-config-title" }, " 网站标题 / sitename ", -1)),
                        _createVNode(_component_n_input, {
                            class: "info-config-content",
                            value: webInfo.value.sitename,
                            "onUpdate:value": _cache[2] || (_cache[2] = function ($event) { return ((webInfo.value.sitename) = $event); }),
                            placeholder: "网站标题"
                        }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "info-config-title" }, " 名片标题 / bussinessCardTitle ", -1)),
                        _createVNode(_component_n_input, {
                            class: "info-config-content",
                            value: webInfo.value.bussinessCardTitle,
                            "onUpdate:value": _cache[3] || (_cache[3] = function ($event) { return ((webInfo.value.bussinessCardTitle) = $event); }),
                            placeholder: "名片标题"
                        }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "info-config-title" }, " 名片描述 / bussinessCardDisc ", -1)),
                        _createVNode(_component_n_input, {
                            class: "info-config-content",
                            value: webInfo.value.bussinessCardDisc,
                            "onUpdate:value": _cache[4] || (_cache[4] = function ($event) { return ((webInfo.value.bussinessCardDisc) = $event); }),
                            placeholder: "名片描述",
                            type: "textarea",
                            rows: 3
                        }, null, 8, ["value"])
                    ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_n_divider, { class: "info-modify-divider usn" }, {
                        default: _withCtx(function () { return _cache[20] || (_cache[20] = [
                            _createTextVNode(" 欢迎卡片配置 ")
                        ]); }),
                        _: 1
                    }),
                    _createElementVNode("div", _hoisted_10, [
                        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "info-config-title" }, " Hover 副标题 / subtitle ", -1)),
                        _createVNode(_component_n_input, {
                            class: "info-config-content",
                            value: webInfo.value.welcomeCard.subtitle,
                            "onUpdate:value": _cache[5] || (_cache[5] = function ($event) { return ((webInfo.value.welcomeCard.subtitle) = $event); }),
                            placeholder: "欢迎卡片-副标题"
                        }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "info-config-title" }, " 打字效果内容 / content ", -1)),
                        _createVNode(_component_n_input, {
                            class: "info-config-content",
                            value: webInfo.value.welcomeCard.content,
                            "onUpdate:value": _cache[6] || (_cache[6] = function ($event) { return ((webInfo.value.welcomeCard.content) = $event); }),
                            placeholder: "欢迎卡片-内容",
                            type: "textarea",
                            rows: 5
                        }, null, 8, ["value"])
                    ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_n_divider, { class: "info-modify-divider usn" }, {
                        default: _withCtx(function () { return _cache[23] || (_cache[23] = [
                            _createTextVNode(" 底部信息配置 ")
                        ]); }),
                        _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(webInfo.value.footDirect, function (value, title) {
                        return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(title), 1),
                            _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_n_input, {
                                    class: "info-config-options-aria",
                                    value: webInfo.value.footDirect[title],
                                    "onUpdate:value": function ($event) { return ((webInfo.value.footDirect[title]) = $event); },
                                    placeholder: "跳转到..."
                                }, null, 8, ["value", "onUpdate:value"]),
                                _createVNode(_component_n_button, {
                                    class: "info-config-bottom-info-set-btn",
                                    onClick: function ($event) { return (deleteBottomField(title)); },
                                    style: { "margin-left": "0.5rem" },
                                    type: "primary"
                                }, {
                                    icon: _withCtx(function () { return [
                                        _createVNode(_component_n_icon, { size: "1.2rem" }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(CustomSVG, {
                                                    icon: "Delete24Filled",
                                                    class: "info-config-bottom-info-set-icon"
                                                })
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    _: 2
                                }, 1032, ["onClick"])
                            ])
                        ]));
                    }), 256)),
                    (!isAddingBottomField.value)
                        ? (_openBlock(), _createBlock(_component_n_button, {
                            key: 0,
                            class: "info-config-row create-botton-info-btn",
                            type: "primary",
                            onClick: createNewBottomField
                        }, {
                            icon: _withCtx(function () { return [
                                _createVNode(_component_n_icon, null, {
                                    default: _withCtx(function () { return [
                                        _createVNode(CustomSVG, { icon: "AddBold" })
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        }))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_n_input, {
                                class: "info-config-title info-config-input",
                                value: addingBottomFieldName.value,
                                "onUpdate:value": _cache[7] || (_cache[7] = function ($event) { return ((addingBottomFieldName).value = $event); }),
                                placeholder: "显示的字段名"
                            }, null, 8, ["value"]),
                            _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_n_input, {
                                    class: "info-config-options-aria add-config-input info-config-input",
                                    value: addingBottomFieldUrl.value,
                                    "onUpdate:value": _cache[8] || (_cache[8] = function ($event) { return ((addingBottomFieldUrl).value = $event); }),
                                    placeholder: "点击后跳转到的位置"
                                }, null, 8, ["value"]),
                                _createVNode(_component_n_button, {
                                    class: "info-config-bottom-info-set-btn",
                                    onClick: createNewBottomFieldActive,
                                    style: { "margin-left": "0.5rem" },
                                    type: "primary"
                                }, {
                                    icon: _withCtx(function () { return [
                                        _createVNode(_component_n_icon, { size: "1.2rem" }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(CustomSVG, {
                                                    icon: "XMark",
                                                    class: "info-config-bottom-info-set-icon"
                                                })
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    _: 1
                                }),
                                _createVNode(_component_n_button, {
                                    class: "info-config-bottom-info-set-btn",
                                    onClick: createNewBottomFieldActive,
                                    style: { "margin-left": "0.5rem" },
                                    type: "primary"
                                }, {
                                    icon: _withCtx(function () { return [
                                        _createVNode(_component_n_icon, { size: "1.2rem" }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(CustomSVG, {
                                                    icon: "Check",
                                                    class: "info-config-bottom-info-set-icon"
                                                })
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ])
                        ]))
                ]),
                _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_n_divider, { class: "info-modify-divider usn" }, {
                        default: _withCtx(function () { return _cache[24] || (_cache[24] = [
                            _createTextVNode(" 联系方式配置 ")
                        ]); }),
                        _: 1
                    }),
                    _createElementVNode("div", _hoisted_19, [
                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "info-config-title" }, " Github ", -1)),
                        _createVNode(_component_n_input, {
                            class: "info-config-content",
                            value: webInfo.value.contractDirect.Github,
                            "onUpdate:value": _cache[9] || (_cache[9] = function ($event) { return ((webInfo.value.contractDirect.Github) = $event); }),
                            placeholder: "Github"
                        }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                        _cache[26] || (_cache[26] = _createElementVNode("span", { class: "info-config-title" }, " QQ ", -1)),
                        _createVNode(_component_n_input, {
                            class: "info-config-content",
                            value: webInfo.value.contractDirect.QQ,
                            "onUpdate:value": _cache[10] || (_cache[10] = function ($event) { return ((webInfo.value.contractDirect.QQ) = $event); }),
                            placeholder: "QQ"
                        }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                        _cache[27] || (_cache[27] = _createElementVNode("span", { class: "info-config-title" }, " Email ", -1)),
                        _createVNode(_component_n_input, {
                            class: "info-config-content",
                            value: webInfo.value.contractDirect.Email,
                            "onUpdate:value": _cache[11] || (_cache[11] = function ($event) { return ((webInfo.value.contractDirect.Email) = $event); }),
                            placeholder: "Email"
                        }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "info-config-title" }, " Bilibili ", -1)),
                        _createVNode(_component_n_input, {
                            class: "info-config-content",
                            value: webInfo.value.contractDirect.Bilibili,
                            "onUpdate:value": _cache[12] || (_cache[12] = function ($event) { return ((webInfo.value.contractDirect.Bilibili) = $event); }),
                            placeholder: "Bilibili"
                        }, null, 8, ["value"])
                    ])
                ])
            ]));
        };
    }
});
